import ChatInterface from './ChatInterface';

// Simply export the ChatInterface as the AICoach component
export default ChatInterface;